import { ClassesService } from '@/classes/services/classes.service';
import { ClassItem } from '@/core/models/class.model';
import { CalendarServices } from '@/core/services/calendar.services';
import { PlaceholderService } from '@/tools/services/placeholder.service';
import { SchoolCalendarService } from '@/tools/services/school-calendar.service';
import { ToolServices } from '@/tools/services/tools.service';

export const ClassBuilderPlaceholderResolver = async (to, from, next) => {
  const classDetailPromise = ClassesService.getClass(to.params.classId);
  const schedulePlaceholderPromise = PlaceholderService.getSchedulePlaceholder(
    to.params.classId,
    to.params.placeholderId
  );
  const placeholdersPromise = PlaceholderService.getPlaceholders(to.params.classId, false)
  const classInfoPromise = ClassesService.getClass(to.params.classId);
  const orgInfoPromise = ToolServices.getInstitutionData();
  
  const [classDetail, schedulePlaceholder, placeholders, classInfo, orgInfo] = await Promise.all([
    classDetailPromise,
    schedulePlaceholderPromise,
    placeholdersPromise,
    classInfoPromise,
    orgInfoPromise
  ]);

  const organizationId = orgInfo[0].organizationId;
  const schoolDayId = classInfo.schoolDay.schoolDayId;

  const schoolDays = await SchoolCalendarService.getSchoolCalendarById(schoolDayId);

  to.meta.schoolDays = schoolDays.dates;
  to.meta.colorDays = schoolDays.color;
  to.meta.classDetail = new ClassItem({
    classId: classDetail.id,
    className: classDetail.name,
  });
  to.meta.schedulePlaceholder = schedulePlaceholder;
  to.meta.placeholders = placeholders;
  
  const firstYear = Number(schoolDays.dates[0].split('-')[0])
  const lastYear = Number(schoolDays.dates[schoolDays.dates.length- 1].split('-')[0])
  
  
  if (lastYear !== firstYear) {
    const startDate = `${firstYear}-01-01`;
    const endDate = `${firstYear}-12-31`;
    const startDate2 = `${lastYear}-01-01`;
    const endDate2 = `${lastYear}-12-31`;
    
    const [holidays1, holidays2] = [...(await Promise.all([
      SchoolCalendarService.holidays(
        organizationId,
        firstYear.toString(),
        startDate,
        endDate,
        'CLASS'
      ),
      SchoolCalendarService.holidays(
        organizationId,
        lastYear.toString(),
        startDate2,
        endDate2,
        'CLASS'
      )
    ]))];
    const holidays = [...holidays1, ...holidays2];

    to.meta.holidays = holidays;
  } else {
    const startDate = `${firstYear}-01-01`;
    const endDate = `${firstYear}-12-31`;
    const holidays = await SchoolCalendarService.holidays(organizationId, firstYear.toString(), startDate, endDate);

    to.meta.holidays = holidays;
  }

  next();
}
